/**
 * Window events the media zip export uses to talk across the app, since the pieces are siblings that
 * never see each other's props: the gallery's Download button, the top-bar progress poller
 * (hooks/useMediaExportProgress) and the header's notification bell all live in different trees.
 *
 * Imported from this file rather than the export barrel — hooks/useMediaExportProgress needs the names
 * and has no business pulling the popover component in with them.
 */

// The user just queued an export: wake the poller instead of waiting up to its next tick.
export const MEDIA_EXPORT_STARTED = 'media-export-started';

// An export the poller was watching reached a terminal state (completed or failed). `detail` carries
// `{ uuid, status }`. The archive arrives as a notification, so the bell refetches its list on this.
export const MEDIA_EXPORT_FINISHED = 'media-export-finished';

export const emitMediaExportStarted = () => window.dispatchEvent(new CustomEvent(MEDIA_EXPORT_STARTED));

export const emitMediaExportFinished = (uuid, status) =>
  window.dispatchEvent(new CustomEvent(MEDIA_EXPORT_FINISHED, { detail: { uuid, status } }));
